<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-card>
              <v-card-title class="pb-5">
                <!--                                    v-if="$can('transaction_create')"-->
                <v-btn to="/panels" rounded color="#A5668B" class="text-white">
                  <v-icon>mdi-backspace-reverse-outline</v-icon>
                  بازگشت
                </v-btn>
                <v-spacer/>
                {{ $route.meta.title }}
                <v-spacer/>
                <v-btn @click="updatePack" color="#50858B" rounded class="text-white">
                  <v-icon>mdi-refresh</v-icon>
                  ذخیره
                </v-btn>
                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>


              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        :rules="rules.title"
                        v-model="title"
                        :error-messages="errors.title"
                        label="عنوان"
                        required
                        outlined
                        dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <price-input :dense="true" :label="'قیمت'" v-model="price"></price-input>

                  </v-flex>
                </v-row>
                <v-row>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        :rules="rules.expire"
                        v-model="expire"
                        :error-messages="errors.expire"
                        type="number"
                        label="تاریخ انقضا(روز)"
                        outlined
                        dense
                    >

                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">

                    <v-select
                        v-model="service"
                        :rules="rules.service"
                        :items="services"
                        item-text="nameLand"
                        item-value="id"
                        label="انتخاب سرویس"
                        :error-messages="errors.service_id"
                        outlined
                        multiple
                        dense
                        return-object
                    ></v-select>
                  </v-flex>
                </v-row>
<!--                <v-row>-->

<!--&lt;!&ndash;                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">&ndash;&gt;-->
<!--&lt;!&ndash;                    <permission-picker&ndash;&gt;-->
<!--&lt;!&ndash;                        v-model="permissions"&ndash;&gt;-->
<!--&lt;!&ndash;                    ></permission-picker>&ndash;&gt;-->

<!--&lt;!&ndash;                  </v-flex>&ndash;&gt;-->
<!--                  <v-flex xs12 sm12 md12 lg12 xl6 class="p-2" >-->
<!--                    <v-select-->
<!--                        v-model="tariff"-->
<!--                        :rules="rules.tariff"-->
<!--                        :items="tariffs"-->
<!--                        :error-messages="errors.tariff_id"-->
<!--                        item-text="title"-->
<!--                        item-value="id"-->
<!--                        label="تعرفه"-->
<!--                        outlined-->
<!--                        dense-->
<!--                        return-object-->
<!--                    ></v-select>-->
<!--                  </v-flex>-->
<!--                </v-row>-->

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                        v-model="owner"
                        :rules="rules.owner"
                        :items="owners"
                        item-text="name"
                        :error-messages="errors.own_number"
                        item-value="id"
                        label="مالک"
                        outlined
                        dense
                        return-object
                    ></v-select>

                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                        v-model="show"
                        :items="shows"
                        item-text="name"
                        item-value="id"
                        :error-messages="errors.show"
                        label="وضعیت"
                        outlined
                        dense
                        return-object
                    ></v-select>

                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="sortOrder"
                        :rules="rules.sortOrder"
                        label="ترتیب نمایش"
                        :error-messages="errors.sort_order"
                        outlined
                        dense
                    >
                    </v-text-field>

                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                        :rules="rules.status"
                        :items="roles"
                        v-model="roleid"
                        item-text="name_fa"
                        item-value="id"
                        :error-messages="errors.role_id"
                        label="انتخاب نقش"
                        outlined
                        dense
                        return-object></v-select>
                  </v-flex>
                </v-row>


                <v-row>
                  <v-flex
                      xs12 sm12 md6 lg6 xl6
                      class="p-2">

                    <sub-line-picker v-model="subline"></sub-line-picker>
                    <!--                                  <v-btn-->
                    <!--                                      block-->
                    <!--                                      dark-->
                    <!--                                      @click="addCount">ا نتخاب تعرفه خطوط-->
                    <!--                                  </v-btn>-->
                  </v-flex>


                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">

                    <smsTariffPicker v-model="tariff"></smsTariffPicker>

                  </v-flex>


                </v-row>


<!--تعرفه های ربات لند -->
                <v-row>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="rb.rb.number"
                        :error-messages="errors.number"
                        type="number"
                        label="شماره"
                        outlined
                        dense
                    >

                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="rb.rb.chat"
                        :error-messages="errors.chat"
                        type="number"
                        label="تعرفه چت"
                        outlined
                        dense
                    />

                  </v-flex>
                </v-row>

                <v-row>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="rb.rb.new"
                        :error-messages="errors.new"
                        type="number"
                        label="شماره جدید"
                        outlined
                        dense
                    >

                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="rb.rb.unique"
                        :error-messages="errors.unique"
                        type="number"
                        label="شماره یکتا"
                        outlined
                        dense
                    />

                  </v-flex>
                </v-row>



                <v-row v-for="(item, i) in features" :key="i">

                  <v-flex xs6 sm6 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="item.key"
                        label="نوع ویژگی"
                        outlined
                        dense>

                    </v-text-field>
                  </v-flex>

                  <v-flex xs6 sm6 md6 lg6 xl6 class="p-2">
                    <v-text-field
                        v-model="item.value"
                        label="مقدار ویژگی"
                        outlined
                        dense>

                    </v-text-field>
                  </v-flex>

                </v-row>
                <v-row>
                  <v-flex
                      :class="features.length>0 ?'xs12 sm12 md6 lg6 xl6' : 'xs12 sm12 md12 lg12 xl12'"
                      class="p-2">

                    <v-btn
                        color="info"
                        block
                        dark
                        @click="addCount"> افزودن تعداد ویژگی
                    </v-btn>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-btn
                        color="red"
                        block
                        dark
                        :disabled="features.length == 0"
                        @click="decreaseCount">کاهش تعداد ویژگی
                    </v-btn>
                  </v-flex>

                </v-row>
                <v-row>
                  <v-flex class="p-2">
                    <v-textarea
                        v-model="description"
                        :rules="rules.description"
                        label="توضیحات"
                        :error-messages="errors.description"
                        outlined
                        dense>

                    </v-textarea>
                  </v-flex>
                </v-row>

              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {SET_BREADCRUMB} from "../../../../core/services/store/breadcrumbs.module";
import subLinePicker from "@/view/pages/pickers/subLinePicker";
import permissionPicker from "@/view/pages/pickers/permissionPicker";
import priceInput from "@/view/pages/pickers/priceInput";
import smsTariffPicker from "@/view/pages/pickers/smsTariffPicker";

export default {
  props: ['id'],
  components: {permissionPicker,priceInput,subLinePicker,smsTariffPicker},

  data() {
    return {
      service: [],
      services: [],
      title: null,
      price: null,
      expire: null,
      subline: {},
      permissions: {},
      roleid:null,
      tariff: {},
      rb:{
        rb:{
          number: null,
          chat: null,
          new: null,
          unique: null
        }
      },
      tariffs: [],
      owner: {id: null},
      owners: [
        {id: 1, name: 'فعال'},
        {id: 0, name: 'غیر فعال'}
      ],
      show: {id: null},
      shows: [
        {id: 1, name: 'فعال'},
        {id: 0, name: 'غیر فعال'}
      ],
      sortOrder: null,
      features: [],
      description: null,
      role: {id: null},
      roles: [],
      errors: [],
      rules: {
        title: [val => (val || '').length > 0 || 'فیلد عنوان الزامی می باشد.'],
        services: [(val) => val.length > 0 || 'فیلد سرویس الزامی می باشد.'],
        price: [val => (val || '').length > 0 || 'فیلد قیمت الزامی می باشد.'],
        // expire: [val => (val || '').length > 0 || 'فیلد تاریخ انقضا الزامی می باشد.'],
      },
      url: 'pack'

    }
  },

  mounted() {
    this.getTariff();
    this.getRoles();
    this.getPack();
    this.fetchIndexData();
    this.services = this.getService().data;
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}]);

  },
  methods: {
    ...mapActions('PermissionsIndex', [
      'fetchIndexData',
      'setQuery',
      'resetState'
    ]),

    addCount() {
      this.features.push({
        id: this.features.length + 1,
        key: null,
        value: null,
      })
    },
    decreaseCount() {
      if (this.features.length > 0) {
        this.features.pop()
      }
    },
    getTariff() {
      this.requestApiGet('tariff',
      ).then(({data}) => {
        this.tariffs = data.data;
      })
    },

    getRoles() {
      this.requestApiGet('admin/roles',
      ).then(response => {
        this.roles = response.data.data;
      })
    },

    getPack() {
      this.requestApiGet(`${this.url}/${this.id}`).then(({data}) => {
        this.service = data.service;
        this.title = data.title;
        this.price = data.price+"";
        this.expire = data.expire;
        this.permissions = data.permission;
        this.tariff = data.tariff_id;
        this.owner = data.own_number;
        this.show = data.show;
        this.description = data.description;
        this.roleid=data.role_id
        this.subline= data.subline_id;
        this.features = data.features;
        this.role = data.role_id;
        this.sortOrder = data.sort_order;
        this.rb.rb.chat=data.rb.chat
        this.rb.rb.number=data.rb.number
        this.rb.rb.new=data.rb.new
        this.rb.rb.unique=data.rb.unique

      })
    },
    updatePack() {
      // let checkedPermission = []
      // for (let a in this.permissions) {
      //   checkedPermission.push(a)
      // }
      let role_data=this.roleid.id
      this.requestApiPost(`${this.url}/${this.id}`, {
        title: this.title,
        price: this.price.replace(/,/g,''),
        expire: this.expire,
        // permissions_id: checkedPermission,
        permissionStatus: this.permissions,
        rb:this.rb.rb,
        tariff_id: this.tariff,
        own_number: this.owner.id,
        show: this.show.id,
        sort_order: this.sortOrder,
        pack_id:this.subline,
        features: this.features,
        description: this.description,
        service_id: this.service.map(item => item.id),
        role_id: role_data,
        _method: 'PUT'
      }).then(({data}) => {
        this.$toast.success('با موفقیت ویرایش شد.');
        this.$router.push({name: 'panels.index'});
      }).catch(({response}) => {
        this.errors = response;
      })
    }
  },


  computed: {
    ...mapGetters(["layoutConfig"]),
    ...mapGetters('PermissionsIndex', ['data', 'total', 'loading']),

    config() {
      return this.layoutConfig();
    }
  },
  watch: {
    query: {
      handler(query) {
        this.setQuery(query)
        this.fetchIndexData()
      },
      deep: true
    }
  },


}
</script>
